import "bootstrap/dist/css/bootstrap.min.css";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-10 mx-auto text-center text-secondary mt-2">
            <a href="https://twitter.com/KM_Imagen" target="_blank" className="text-decoration-none text-secondary">
              <i className="bi bi-twitter me-3"></i>
            </a>
            <a href="https://www.linkedin.com/company/imagen-s.a./" target="_blank" className="text-decoration-none text-secondary">
              <i className="bi bi-linkedin me-3"></i>
            </a>
            <a href="https://www.facebook.com/ImagenS.A" target="_blank" className="text-decoration-none text-secondary">
              <i className="bi bi-facebook me-3"></i>
            </a>
            
          </div>
          <div className="col-10 mx-auto text-center text-secondary mt-1">
            <p className="textFooter">
              <i className="bi bi-r-circle"></i> Desarrollado por{" "}
              <strong>
                <a
                  href="https://www.imagen.cl"
                  target="_blank"
                  className="text-decoration-none"
                >
                  Imagen
                </a>
              </strong>
              , impulsamos la transformacion digital.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
